<template>
  <div>
    <div class="yk-wrap-fixed wlx-site-manager-wrapper">
      <header class="u-school-manager-head site-manager-head-con">
        <span class="fl sp-test-detail-title">{{meetTitle}}</span>
        <!-- <div style="float:right;"> -->
          <el-form :inline="true">
            <el-form-item>
              <div style="width:48%;float:left;margin-right:15px;">
                <el-input v-model="CreateDisplayName" placeholder="请输入申请人" clearable></el-input>
              </div>
              <div style="width:48%;float:left">
                <el-input v-model="hotelTitle" placeholder="请输入单位" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <el-button type="primary" icon="el-icon-search" @click="openAddDialog">添加</el-button>
              <el-button type="primary" icon="wl-icon-ai207" @click="goBack"></el-button>
            </el-form-item>
          </el-form>
        <!-- </div> -->
      </header>
      <div class="wlx-table-content">
        <el-table
          :data="list"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="hotelTitle" show-overflow-tooltip label="酒店名称"></el-table-column>
          <el-table-column prop="price" show-overflow-tooltip label="价格" width="160"></el-table-column>
          <el-table-column prop="isBreakfast" label="是否含早" show-overflow-tooltip width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.isBreakfast==0">不含早</span>
              <span v-else-if="scope.row.isBreakfast==1">含早</span>
            </template>
          </el-table-column>
          <el-table-column prop="isEnable" label="是否启用" show-overflow-tooltip width="160">
            <template slot-scope="scope">
              <el-switch @change="editHotelEnble(scope.row.id,scope.row.isEnable)"
                v-model="scope.row.isEnable"
                active-text="启用"
                inactive-text="禁用">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="el-icon-view"
                @click="openEditDialog(scope.row)"
                type="primary"
                title="修改"
              ></el-button>
              <el-button size="mini"
                        type="danger"
                        class="el-icon-delete"
                        @click="deleteHotel(scope.row.id)"
              titlt="删除"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="wl-pagination-text"
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="tosititle"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form label-width="80px" :model="form">
        <el-form-item label="酒店名称">
          <el-input v-model="form.titlt"></el-input>
        </el-form-item>
        <el-form-item label="价格">
          <el-input-number v-model="form.price" :min="0"></el-input-number>
          <span>元/晚</span>
        </el-form-item>
        <el-form-item label="是否含早">
          <el-radio v-model="form.isBreakfast" :label="0">不含早</el-radio>
          <el-radio v-model="form.isBreakfast" :label="1">含早</el-radio>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrEditHotel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      ids: [],
      CreateDisplayName: "",
      hotelTitle:"",
      meetTitle: "",
      dialogVisible:false,
      tosititle:'',
      form:{
        id:'',
        titlt:'',
        price:'',
        isBreakfast:''
      }
    };
  },
  props: {
    activityId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getHotelList(1);
  },
  methods: {
    getHotelList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/Hotel/getHotelList", {
          hotelTitle: this.hotelTitle,
          activityId: this.activityId,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.meetTitle = rst.meetTitle;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getHotelList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getHotelList(1);
    },
    openAddDialog(){
      this.dialogVisible = true;
      this.tosititle = "添加酒店";
      this.form = {
        id:'',
        titlt:'',
        price:'',
        isBreakfast:''
      };
    },
    addOrEditHotel(){
      var that = this;
      this.$http
        .post("/api/XOrg/Hotel/addOrEditHotel", {
          hotelId:this.form.id,
          hotelTitle: this.form.titlt,
          price: this.form.price,
          isBreakfast: this.form.isBreakfast,
          activityId: this.activityId
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.dialogVisible = false;
            that.getHotelList(1);
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    handleClose(){
       this.dialogVisible = false;
    },
    openEditDialog(row){
      this.dialogVisible = true;
      this.tosititle = "修改酒店";
      this.form = {
        id:row.id,
        titlt:row.hotelTitle,
        price:row.price,
        isBreakfast:row.isBreakfast
      };
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    deleteHotel(id) {
      this.$confirm("此操作将删除该酒店, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var that = this;
          this.$http
            .post("/api/XOrg/Hotel/deleteHotelEnble", {
              hotelIds: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getHotelList(1);
              }else{
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getHotelList(1);
    },
    goBack() {
      this.$router.push({
        name: "MeetingManager"
      });
    },
    editHotelEnble(id,value){
      var that = this;
        this.$http
          .post("/api/XOrg/Hotel/editHotelEnble", {
            hotelId: id,
            isEnable: value
          })
          .then(rst => {
            if (rst.code === 1) {
              that.$message({
                message: rst.msg,
                type: "success"
              });
            }else{
              that.$message.warning(rst.msg);
            }
          });
    }
  }
};
</script>

<style lang="scss">
.yk-wrap-fixed {
  .sp-test-detail-title {
    padding: 0 15px;
    font-size: 16px;
    color: #2d82ff;
    // border-bottom: 2px solid #2d82ff;
    line-height: 59px;
    min-width: 30px;
    text-align: center;
  }
  .wlx-table-content {
    margin-top: 84px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .wl-pagination-text {
    text-align: center;
    margin-top: 30px;
  }
  .site-manager-head-con {
    text-align: right;
  }
  .el-form-item__content {
    .el-button {
      padding: 8px 15px;
    }
  }
  .export-button-a{
    color: #fff;
    background: #409EFF;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
